import type { MultiSelectProps as MantineMultiSelectProps } from '@mantine/core';
import { MultiSelect as MantineMultiSelect } from '@mantine/core';
import { IconChevronDown } from 'ui-icons';

import classes from './MultiSelect.module.css';

interface MultiSelectProps extends MantineMultiSelectProps {}

const MultiSelectDefaults = MantineMultiSelect.extend({
  classNames: {
    root: classes.root,
    input: classes.input,
    dropdown: classes.dropdown,
    empty: classes.empty,
    option: classes.option,
    options: classes.options,
    pill: classes.pill,
  },
  defaultProps: {
    size: 'md',
    rightSection: <IconChevronDown size="12px" />,
    // TODO: (UI) No designs exist for multiple selected options in MultiSelect - @sem0701
    withCheckIcon: false,
  },
});

/**
 *
 * Read Only Styles: We need to apply them to both the wrapper for inheritance and the input for styles
 *
 */
const MultiSelect = ({ wrapperProps = {}, ...props }: MultiSelectProps) => {
  return (
    <MantineMultiSelect
      {...props}
      wrapperProps={{ ...wrapperProps, readOnly: props.readOnly }}
      scrollAreaProps={{
        type: 'auto',
      }}
    />
  );
};

export { MultiSelect, MultiSelectDefaults };
export type { MultiSelectProps };
